export default {
    props: {
        seriesAggregate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.aggregate'
        }, 
        seriesAxis: {
            type: String,
            default: undefined,
            kComposite: 'series.axis'
        }, 
        seriesBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.border.color'
        }, 
        seriesBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.border.dashType'
        }, 
        seriesBorderOpacity: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.border.opacity'
        }, 
        seriesBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.border.width'
        }, 
        seriesCategoryAxis: {
            type: String,
            default: undefined,
            kComposite: 'series.categoryAxis'
        }, 
        seriesCategoryField: {
            type: String,
            default: undefined,
            kComposite: 'series.categoryField'
        }, 
        seriesCloseField: {
            type: String,
            default: undefined,
            kComposite: 'series.closeField'
        }, 
        seriesColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.color'
        }, 
        seriesColorField: {
            type: String,
            default: undefined,
            kComposite: 'series.colorField'
        }, 
        seriesConnectorsColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.connectors.color'
        }, 
        seriesConnectorsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.connectors.padding'
        }, 
        seriesConnectorsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.connectors.width'
        }, 
        seriesCurrentField: {
            type: String,
            default: undefined,
            kComposite: 'series.currentField'
        }, 
        seriesDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.dashType'
        }, 
        seriesData: {
            type: Array,
            default: undefined,
            kComposite: 'series.data'
        }, 
        seriesDownColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.downColor'
        }, 
        seriesDownColorField: {
            type: String,
            default: undefined,
            kComposite: 'series.downColorField'
        }, 
        seriesSegmentSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'series.segmentSpacing'
        }, 
        seriesSummaryField: {
            type: String,
            default: undefined,
            kComposite: 'series.summaryField'
        }, 
        seriesNeckRatio: {
            type: Number,
            default: undefined,
            kComposite: 'series.neckRatio'
        }, 
        seriesDynamicSlope: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.dynamicSlope'
        }, 
        seriesDynamicHeight: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.dynamicHeight'
        }, 
        seriesErrorBarsValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'series.errorBars.value'
        }, 
        seriesErrorBarsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.errorBars.visual'
        }, 
        seriesErrorBarsXValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'series.errorBars.xValue'
        }, 
        seriesErrorBarsYValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'series.errorBars.yValue'
        }, 
        seriesErrorBarsEndCaps: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.errorBars.endCaps'
        }, 
        seriesErrorBarsColor: {
            type: String,
            default: undefined,
            kComposite: 'series.errorBars.color'
        }, 
        seriesErrorBarsLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.errorBars.line.width'
        }, 
        seriesErrorBarsLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.errorBars.line.dashType'
        }, 
        seriesErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'series.errorLowField'
        }, 
        seriesErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'series.errorHighField'
        }, 
        seriesXErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'series.xErrorLowField'
        }, 
        seriesXErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'series.xErrorHighField'
        }, 
        seriesYErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'series.yErrorLowField'
        }, 
        seriesYErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'series.yErrorHighField'
        }, 
        seriesExplodeField: {
            type: String,
            default: undefined,
            kComposite: 'series.explodeField'
        }, 
        seriesField: {
            type: String,
            default: undefined,
            kComposite: 'series.field'
        }, 
        seriesFromField: {
            type: String,
            default: undefined,
            kComposite: 'series.fromField'
        }, 
        seriesToField: {
            type: String,
            default: undefined,
            kComposite: 'series.toField'
        }, 
        seriesNoteTextField: {
            type: String,
            default: undefined,
            kComposite: 'series.noteTextField'
        }, 
        seriesLowerField: {
            type: String,
            default: undefined,
            kComposite: 'series.lowerField'
        }, 
        seriesQ1Field: {
            type: String,
            default: undefined,
            kComposite: 'series.q1Field'
        }, 
        seriesMedianField: {
            type: String,
            default: undefined,
            kComposite: 'series.medianField'
        }, 
        seriesQ3Field: {
            type: String,
            default: undefined,
            kComposite: 'series.q3Field'
        }, 
        seriesUpperField: {
            type: String,
            default: undefined,
            kComposite: 'series.upperField'
        }, 
        seriesMeanField: {
            type: String,
            default: undefined,
            kComposite: 'series.meanField'
        }, 
        seriesOutliersField: {
            type: String,
            default: undefined,
            kComposite: 'series.outliersField'
        }, 
        seriesGap: {
            type: Number,
            default: undefined,
            kComposite: 'series.gap'
        }, 
        seriesHighField: {
            type: String,
            default: undefined,
            kComposite: 'series.highField'
        }, 
        seriesHighlightBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'series.highlight.border.color'
        }, 
        seriesHighlightBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.border.opacity'
        }, 
        seriesHighlightBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.border.width'
        }, 
        seriesHighlightColor: {
            type: String,
            default: undefined,
            kComposite: 'series.highlight.color'
        }, 
        seriesHighlightLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.highlight.line.dashType'
        }, 
        seriesHighlightLineColor: {
            type: String,
            default: undefined,
            kComposite: 'series.highlight.line.color'
        }, 
        seriesHighlightLineOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.line.opacity'
        }, 
        seriesHighlightLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.line.width'
        }, 
        seriesHighlightOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.opacity'
        }, 
        seriesHighlightToggle: {
            type: Function,
            default: undefined,
            kComposite: 'series.highlight.toggle'
        }, 
        seriesHighlightVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.highlight.visible'
        }, 
        seriesHighlightVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.highlight.visual'
        }, 
        seriesHoleSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.holeSize'
        }, 
        seriesLabelsAlign: {
            type: String,
            default: undefined,
            kComposite: 'series.labels.align'
        }, 
        seriesLabelsBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.background'
        }, 
        seriesLabelsBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.border.color'
        }, 
        seriesLabelsBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.border.dashType'
        }, 
        seriesLabelsBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.labels.border.width'
        }, 
        seriesLabelsColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.color'
        }, 
        seriesLabelsDistance: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.distance'
        }, 
        seriesLabelsFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.font'
        }, 
        seriesLabelsFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.format'
        }, 
        seriesLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin'
        }, 
        seriesLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin.bottom'
        }, 
        seriesLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin.left'
        }, 
        seriesLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin.right'
        }, 
        seriesLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin.top'
        }, 
        seriesLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding'
        }, 
        seriesLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding.bottom'
        }, 
        seriesLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding.left'
        }, 
        seriesLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding.right'
        }, 
        seriesLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding.top'
        }, 
        seriesLabelsPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.position'
        }, 
        seriesLabelsRotation: {
            type: [String, Number],
            default: undefined,
            kComposite: 'series.labels.rotation'
        }, 
        seriesLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.template'
        }, 
        seriesLabelsVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.labels.visible'
        }, 
        seriesLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.labels.visual'
        }, 
        seriesLabelsFromBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.background'
        }, 
        seriesLabelsFromBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.border.color'
        }, 
        seriesLabelsFromBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.border.dashType'
        }, 
        seriesLabelsFromBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.labels.from.border.width'
        }, 
        seriesLabelsFromColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.color'
        }, 
        seriesLabelsFromFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.font'
        }, 
        seriesLabelsFromFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.format'
        }, 
        seriesLabelsFromMargin: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin'
        }, 
        seriesLabelsFromMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin.bottom'
        }, 
        seriesLabelsFromMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin.left'
        }, 
        seriesLabelsFromMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin.right'
        }, 
        seriesLabelsFromMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin.top'
        }, 
        seriesLabelsFromPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding'
        }, 
        seriesLabelsFromPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding.bottom'
        }, 
        seriesLabelsFromPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding.left'
        }, 
        seriesLabelsFromPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding.right'
        }, 
        seriesLabelsFromPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding.top'
        }, 
        seriesLabelsFromPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.position'
        }, 
        seriesLabelsFromTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.template'
        }, 
        seriesLabelsFromVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.labels.from.visible'
        }, 
        seriesLabelsToBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.background'
        }, 
        seriesLabelsToBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.border.color'
        }, 
        seriesLabelsToBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.border.dashType'
        }, 
        seriesLabelsToBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.labels.to.border.width'
        }, 
        seriesLabelsToColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.color'
        }, 
        seriesLabelsToFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.font'
        }, 
        seriesLabelsToFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.format'
        }, 
        seriesLabelsToMargin: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin'
        }, 
        seriesLabelsToMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin.bottom'
        }, 
        seriesLabelsToMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin.left'
        }, 
        seriesLabelsToMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin.right'
        }, 
        seriesLabelsToMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin.top'
        }, 
        seriesLabelsToPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding'
        }, 
        seriesLabelsToPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding.bottom'
        }, 
        seriesLabelsToPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding.left'
        }, 
        seriesLabelsToPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding.right'
        }, 
        seriesLabelsToPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding.top'
        }, 
        seriesLabelsToPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.position'
        }, 
        seriesLabelsToTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.template'
        }, 
        seriesLabelsToVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.labels.to.visible'
        }, 
        seriesLine: {
            type: String,
            default: undefined,
            kComposite: 'series.line'
        }, 
        seriesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'series.line.color'
        }, 
        seriesLineOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.line.opacity'
        }, 
        seriesLineWidth: {
            type: String,
            default: undefined,
            kComposite: 'series.line.width'
        }, 
        seriesLineStyle: {
            type: String,
            default: undefined,
            kComposite: 'series.line.style'
        }, 
        seriesLowField: {
            type: String,
            default: undefined,
            kComposite: 'series.lowField'
        }, 
        seriesMargin: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin'
        }, 
        seriesMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin.bottom'
        }, 
        seriesMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin.left'
        }, 
        seriesMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin.right'
        }, 
        seriesMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin.top'
        }, 
        seriesMarkersBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.background'
        }, 
        seriesMarkersBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.border'
        }, 
        seriesMarkersBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.border.color'
        }, 
        seriesMarkersBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.border.width'
        }, 
        seriesMarkersFromBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.from.background'
        }, 
        seriesMarkersFromBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.from.border'
        }, 
        seriesMarkersFromBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.from.border.color'
        }, 
        seriesMarkersFromBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.from.border.width'
        }, 
        seriesMarkersFromSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.from.size'
        }, 
        seriesMarkersFromType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.from.type'
        }, 
        seriesMarkersFromVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.markers.from.visible'
        }, 
        seriesMarkersFromVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.from.visual'
        }, 
        seriesMarkersFromRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.from.rotation'
        }, 
        seriesMarkersSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.size'
        }, 
        seriesMarkersToBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.to.background'
        }, 
        seriesMarkersToBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.to.border'
        }, 
        seriesMarkersToBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.to.border.color'
        }, 
        seriesMarkersToBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.to.border.width'
        }, 
        seriesMarkersToSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.to.size'
        }, 
        seriesMarkersToType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.to.type'
        }, 
        seriesMarkersToVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.markers.to.visible'
        }, 
        seriesMarkersToVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.to.visual'
        }, 
        seriesMarkersToRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.to.rotation'
        }, 
        seriesMarkersType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.type'
        }, 
        seriesMarkersVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.markers.visible'
        }, 
        seriesMarkersVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.visual'
        }, 
        seriesMarkersRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.rotation'
        }, 
        seriesOutliersBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.outliers.background'
        }, 
        seriesOutliersBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.outliers.border'
        }, 
        seriesOutliersBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.outliers.border.color'
        }, 
        seriesOutliersBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.outliers.border.width'
        }, 
        seriesOutliersSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.outliers.size'
        }, 
        seriesOutliersType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.outliers.type'
        }, 
        seriesOutliersRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.outliers.rotation'
        }, 
        seriesExtremesBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.extremes.background'
        }, 
        seriesExtremesBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.extremes.border'
        }, 
        seriesExtremesBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.extremes.border.color'
        }, 
        seriesExtremesBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.extremes.border.width'
        }, 
        seriesExtremesSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.extremes.size'
        }, 
        seriesExtremesType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.extremes.type'
        }, 
        seriesExtremesRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.extremes.rotation'
        }, 
        seriesMaxSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.maxSize'
        }, 
        seriesMinSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.minSize'
        }, 
        seriesMissingValues: {
            type: String,
            default: undefined,
            kComposite: 'series.missingValues'
        }, 
        seriesStyle: {
            type: String,
            default: undefined,
            kComposite: 'series.style'
        }, 
        seriesName: {
            type: String,
            default: undefined,
            kComposite: 'series.name'
        }, 
        seriesNegativeColor: {
            type: String,
            default: undefined,
            kComposite: 'series.negativeColor'
        }, 
        seriesNegativeValuesColor: {
            type: String,
            default: undefined,
            kComposite: 'series.negativeValues.color'
        }, 
        seriesNegativeValuesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.negativeValues.visible'
        }, 
        seriesOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.opacity'
        }, 
        seriesOpenField: {
            type: String,
            default: undefined,
            kComposite: 'series.openField'
        }, 
        seriesOverlayGradient: {
            type: String,
            default: undefined,
            kComposite: 'series.overlay.gradient'
        }, 
        seriesPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.padding'
        }, 
        seriesSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.size'
        }, 
        seriesSizeField: {
            type: String,
            default: undefined,
            kComposite: 'series.sizeField'
        }, 
        seriesSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'series.spacing'
        }, 
        seriesStack: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'series.stack'
        }, 
        seriesStackType: {
            type: String,
            default: undefined,
            kComposite: 'series.stack.type'
        }, 
        seriesStackGroup: {
            type: String,
            default: undefined,
            kComposite: 'series.stack.group'
        }, 
        seriesStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'series.startAngle'
        }, 
        seriesTargetBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.target.border'
        }, 
        seriesTargetBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.target.border.color'
        }, 
        seriesTargetBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.target.border.dashType'
        }, 
        seriesTargetBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.target.border.width'
        }, 
        seriesTargetColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.target.color'
        }, 
        seriesTargetLineWidth: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'series.target.line.width'
        }, 
        seriesTargetField: {
            type: String,
            default: undefined,
            kComposite: 'series.targetField'
        }, 
        seriesTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.background'
        }, 
        seriesTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.border.color'
        }, 
        seriesTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.border.width'
        }, 
        seriesTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.color'
        }, 
        seriesTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.font'
        }, 
        seriesTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.format'
        }, 
        seriesTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding'
        }, 
        seriesTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding.bottom'
        }, 
        seriesTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding.left'
        }, 
        seriesTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding.right'
        }, 
        seriesTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding.top'
        }, 
        seriesTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.tooltip.template'
        }, 
        seriesTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.tooltip.visible'
        }, 
        seriesType: {
            type: String,
            default: undefined,
            kComposite: 'series.type'
        }, 
        seriesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.visible'
        }, 
        seriesVisibleInLegend: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.visibleInLegend'
        }, 
        seriesVisibleInLegendField: {
            type: String,
            default: undefined,
            kComposite: 'series.visibleInLegendField'
        }, 
        seriesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.visual'
        }, 
        seriesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.width'
        }, 
        seriesXAxis: {
            type: String,
            default: undefined,
            kComposite: 'series.xAxis'
        }, 
        seriesXField: {
            type: String,
            default: undefined,
            kComposite: 'series.xField'
        }, 
        seriesYAxis: {
            type: String,
            default: undefined,
            kComposite: 'series.yAxis'
        }, 
        seriesYField: {
            type: String,
            default: undefined,
            kComposite: 'series.yField'
        }, 
        seriesNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.position'
        }, 
        seriesNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.icon.background'
        }, 
        seriesNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.icon.border.color'
        }, 
        seriesNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.icon.border.width'
        }, 
        seriesNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.icon.size'
        }, 
        seriesNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.icon.type'
        }, 
        seriesNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.notes.icon.visible'
        }, 
        seriesNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.background'
        }, 
        seriesNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.border.color'
        }, 
        seriesNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.border.dashType'
        }, 
        seriesNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.label.border.width'
        }, 
        seriesNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.color'
        }, 
        seriesNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.font'
        }, 
        seriesNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.notes.label.template'
        }, 
        seriesNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.notes.label.visible'
        }, 
        seriesNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.label.rotation'
        }, 
        seriesNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.format'
        }, 
        seriesNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.position'
        }, 
        seriesNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.line.dashType'
        }, 
        seriesNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.line.width'
        }, 
        seriesNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.line.color'
        }, 
        seriesNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.line.length'
        }, 
        seriesNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.notes.visual'
        }, 
        seriesZIndex: {
            type: Number,
            default: undefined,
            kComposite: 'series.zIndex'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Series.js